import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/operations/')({
  component: () => <PageStub title="Operations Hub" description="Business operations management" />,
});
